import { getStartSessionTimestamp } from '@mindly/ui-components';
import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const futureSessionsSelector = (state: RootState) =>
  Object.values(state.consultationsNewList.futureSessions).sort((a, b) => {
    return getStartSessionTimestamp(a.consultation_time) - getStartSessionTimestamp(b.consultation_time);
  });
export const previousSessionsSelector = (state: RootState) =>
  Object.values(state.consultationsNewList.previousSessions).sort((a, b) => {
    return getStartSessionTimestamp(b.consultation_time) - getStartSessionTimestamp(a.consultation_time);
  });
export const hasMorePreviousSessionsSelector = (state: RootState) =>
  state.consultationsNewList.previousSessionsTotal > Object.values(state.consultationsNewList.previousSessions).length;

export const futureSessionsLoadedSelector = (state: RootState) => state.consultationsNewList.futureSessionsLoaded;
export const previousSessionsLoadedSelector = (state: RootState) => state.consultationsNewList.previousSessionsLoaded;
